import React from 'react';
import { TimeText } from '../components';
import { ClientMessageQueueHelper } from '../helpers';
import { ChatMessage, LiveChatData, ScreenType, SocketChatSession } from '../types';

interface TypingIndicatorProps {
  screenType: ScreenType;
  currentCRef: React.MutableRefObject<SocketChatSession | null>;
  hasSocketError: boolean;
  messages?: ChatMessage[] | null;
  agentTyping?: boolean;
  clientTypingSessions?: Record<string, boolean>;
  chatData?: LiveChatData | null;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  screenType,
  currentCRef,
  hasSocketError = false,
  agentTyping = false,
  messages = null,
  clientTypingSessions = {},
  chatData = null
}) => {
  const booleans: boolean[] = [];

  if (hasSocketError) {
    return null;
  }

  if (screenType === ScreenType.Client && messages) {
    const hasLiveChatStarted = Boolean(currentCRef.current?.assign?.start);

    if (hasLiveChatStarted) {
      booleans.push(agentTyping);
    } else {
      booleans.push(ClientMessageQueueHelper.isAwaitingBotResponse(currentCRef.current, messages));
    }
  }
  if (screenType === ScreenType.Agent && Object.keys(clientTypingSessions).length > 0) {
    const currentSessionId = currentCRef.current?.id;
    const isClientTyping = currentSessionId && clientTypingSessions[currentSessionId] ? true : false;
    booleans.push(isClientTyping);
  }

  if (booleans.length === 0 || booleans.some(boolean => boolean === false)) {
    return null;
  }

  return (
    <>
      <TimeText chatData={chatData} />
      <div className="chatyme-message-container chatyme-chat-received chatyme-typing-indicator" aria-live="polite">
        <div className="chatyme-typing-dots">
          <span className="chatyme-typing-dot" />
          <span className="chatyme-typing-dot" />
          <span className="chatyme-typing-dot" />
        </div>
      </div>
    </>
  );
};

export default TypingIndicator;

